// src/routes/domains/quantum/index.ts
import { quantumRoutes } from './quantum.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for Quantum routes.
 * Enables code splitting: the Quantum routes chunk will only load when needed.
 */
export const loadQuantumRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(quantumRoutes);
};